import { createElement, useState } from 'react';
import { connect } from 'react-redux';
import {
  Typography,
  CircularProgress,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';

const EnumSelectorDialog = ({
  onSubmit,
  onCancel,

  // Should be a single EnumSelectorBase extension
  child,
  entities,
}) => {
  // TODO: should just inline with dialog base and accept that the form is operating on strings and not IDs...
  const [selected, setSelected] = useState();
  const [submitting, setSubmitting] = useState('');
  const [error, setError] = useState();
  return (
    <Dialog open={entities.length > 0} fullWidth>
      <DialogTitle>{child?.displayName}</DialogTitle>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          setSubmitting('Processing Request');
          onSubmit(selected)
            .then(() => setSubmitting(''))
            .catch((e) => {
              setSubmitting('');
              setError(e.message);
            });
        }}
        onReset={onCancel}
        id={child?.displayName}
      >
        <DialogContent>
          {createElement(child, { entities, onChange: setSelected })}
          {error ? (
            <Typography sx={{ padding: '10px' }} color="error">
              {error.replaceAll('<br />', '\n')}
            </Typography>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button type="reset" form={child?.displayName}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="success"
            type="submit"
            form={child?.displayName}
            disabled={submitting}
          >
            {submitting ? (
              <CircularProgress color="success" size="24px" aria-label="Processing…" />
            ) : (
              'Submit'
            )}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default connect()(EnumSelectorDialog);
